import React from 'react';
import PropTypes from 'prop-types';

const Feature = ({ data }) => (
  <div className="col-15 col-lg-5">
    <a className="features__feature features__feature--hover features__feature--height-100 features__feature--shadow features__feature--p-20 features__feature--v-align-start">
      {
        data.svgIcon
          ? (
            <>
              <svg className="features__feature__image-hover no-filter">
                <use xlinkHref={data.svgIcon} />
              </svg>
            </>
          )
          : <i className={`${data.icon} features__feature__icon`} />
      }
      <h3 className="features__feature__title">{data.title}</h3>
      <p className="features__feature__description">{data.description}</p>
    </a>
  </div>
);

Feature.propTypes = {
  data: PropTypes.object,
};

export default Feature;
